var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTachometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C6.486 4 2 8.486 2 14C2 15.55 2.354 17.045 3.051 18.445C3.221 18.785 3.567 19 3.946 19H20.053C20.432 19 20.779 18.785 20.949 18.445C21.646 17.045 22 15.55 22 14C22 8.486 17.514 4 12 4ZM19.41 17H4.59C4.198 16.042 4 15.035 4 14C4 9.589 7.589 6 12 6C16.411 6 20 9.589 20 14C20 15.035 19.802 16.042 19.41 17Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.939 12.939C10.771 13.05 10.616 13.201 10.499 13.379C10.034 14.087 10.231 15.036 10.939 15.5C11.646 15.965 12.596 15.768 13.06 15.06L17.022 9.02199C17.028 9.01099 17.029 8.99799 17.022 8.98699C17.012 8.97199 16.992 8.96799 16.977 8.97699L10.939 12.939Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTachometer);
export default __webpack_public_path__ + "static/media/tachometer.06104426.svg";
export { ForwardRef as ReactComponent };